import * as React from 'react'
import { observer, inject } from 'mobx-react'
import { StateType } from '../state/state'
import { Label } from '../../../components/ui/Label'
import { FilterButton } from '../../../components/ui/FilterButton'
import { ChallengeColumnName } from '../types'

interface Props {
  className?: string
  isHorizontal?: boolean
}

export const ChallengesButtons: React.FC<Props> = ({ className = '', isHorizontal = false }) => {
  return (
    <div className={`-challenges-buttons ${className}`}>
      {isHorizontal ? (
        <Buttons wrap={true} />
      ) : (
        <div className="">
          {/* Label duplicated for mobile! look in ScatterplotContainer */}
          <Label className="mb2" label="EMISSIONS BY CHALLENGE" />

          <Buttons wrap={false} />
        </div>
      )}
    </div>
  )
}

interface ButtonsProps {
  className?: string
  wrap: boolean
  state?: StateType
}

const Buttons: React.FC<ButtonsProps> = inject('state')(
  observer(({ className = '', state, wrap }) => {
    const { challenges, toggleChallenge } = state.ScatterplotState

    return (
      <div className={`flex items-center ${wrap ? 'overflow-x-auto' : ''} ${className}`}>
        <div className={`flex ${wrap ? 'flex-nowrap add-prod-padding' : 'flex-wrap'}`}>
          {Object.entries(challenges).map(([challengeColumnName, { isActive, name }]) => (
            <FilterButton
              key={name}
              className=""
              isActive={isActive}
              label={name}
              onClick={() => toggleChallenge(challengeColumnName as ChallengeColumnName)}
            />
          ))}
        </div>
      </div>
    )
  })
)
